import { QuestionCircleOutlined } from '@ant-design/icons';
import { useTheme, jsx } from '@emotion/react';
import { Constraints } from '../constraints/index.js';
import { OptionalText } from './styles.js';
import { PositionEnum } from '../tooltip/types.js';
import { Stack } from '../spacings/stack/stack.js';
import { Label } from '../label/label.js';
import { Tooltip } from '../tooltip/tooltip.js';
import { Inline } from '../spacings/inline/inline.js';

var FieldLabel = function FieldLabel(props) {
  var title = props.title,
      _props$tone = props.tone,
      tone = _props$tone === void 0 ? 'default' : _props$tone,
      _props$htmlFor = props.htmlFor,
      htmlFor = _props$htmlFor === void 0 ? '' : _props$htmlFor,
      hint = props.hint,
      _props$hintPosition = props.hintPosition,
      hintPosition = _props$hintPosition === void 0 ? PositionEnum.TOP_CENTER : _props$hintPosition,
      _props$horizontalCons = props.horizontalConstraint,
      horizontalConstraint = _props$horizontalCons === void 0 ? 'scale' : _props$horizontalCons,
      optionalText = props.optionalText;
  var theme = useTheme();
  return jsx(Constraints.Horizontal, {
    constraint: horizontalConstraint
  }, jsx(Stack, {
    scale: "xs"
  }, jsx(Inline, {
    alignItems: "center",
    scale: "xs"
  }, jsx("div", null, jsx(Label, {
    htmlFor: htmlFor,
    tone: tone
  }, title, ' ', optionalText && jsx(OptionalText, null, "(".concat(optionalText, ")")))), hint && jsx(Tooltip, {
    innerJSX: hint,
    position: hintPosition
  }, jsx(QuestionCircleOutlined, {
    style: {
      fontSize: '8px',
      color: theme.palette.brand.navy
    }
  })))));
};
FieldLabel.displayName = 'FieldLabel';
FieldLabel.defaultProps = {
  horizontalConstraint: 'scale'
};

export { FieldLabel };
//# sourceMappingURL=field-label.js.map
